import React, { useId } from 'react'

import { NotificationPreferenceRowSkeleton } from './NotificationPreferenceRowSkeleton'

const DEFAULT_ROW_COUNT = 3

interface NotificationSectionSkeletonProps {
  rowCount?: number
}

export const NotificationSectionSkeleton: React.FC<
  NotificationSectionSkeletonProps
> = ({ rowCount = DEFAULT_ROW_COUNT }) => {
  const baseId = useId()

  return (
    <div className="bg-white max-w-[1080px]">
      <div className="gap-8">
        <div className="w-48 mb-4 rounded h-7 bg-gray-light-200 animate-pulse" />
        <div className="space-y-0 border border-solid border-gray-light-200 rounded-2xl">
          {Array.from({ length: rowCount }).map((_, index) => (
            <NotificationPreferenceRowSkeleton
              key={`${baseId}-${index}`}
              showSeparator={index < rowCount - 1}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
